import { useState } from 'react'
import { Stack, Typography } from '@mui/material'
import ArrowRoundBlackSvg from '~/@ui/_sharedSvgs/ui/ArrowRoundBlack.svg?react'

type Props = {
  title: string
  data: { label: string; value?: string | number }[]
  className?: string
}

export const DataTable = ({ title, data, className = '' }: Props) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Stack className={`gap-4 mt-12 ${className}`}>
      <Stack
        className="flex-row justify-between cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}>
        <Typography className="text-base font-bold text-zBlack200">
          {title}
        </Typography>
        <ArrowRoundBlackSvg
          className={`${isOpen ? 'rotate-180' : 'rotate-0'}`}
        />
      </Stack>
      <Stack className={`gap-2 ${isOpen ? '' : 'hidden'}`}>
        {data.map((item) =>
          item.value ? (
            <Stack
              key={item.label}
              className="flex-row h-14 justify-between items-center px-4 bg-zGrey200 rounded-4d">
              <Typography className="text-3d font-medium text-zBlack200">
                {item.label}
              </Typography>
              <Typography className="text-lg font-bold text-zBlack200">
                {item.value}
              </Typography>
            </Stack>
          ) : null
        )}
      </Stack>
    </Stack>
  )
}
